import React, { Component } from "react";
import "./ErrorPage.css";

class ErrorPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div className="general">
                <img className="veriff-logo-with-name" alt="veriff-logo" src="/veriff-logo-with-text.png" />

                <div className="message">
                    <h2 className="title">Wrong Link</h2>
                    <p className="desc">
                        {" "}
                        This link does not exist. <br></br>
                        Contact us and we will figure it out.
                    </p>
                </div>
            </div>
        );
    }
}

export default ErrorPage;
